import React from "react";
import { ShieldOff } from "lucide-react";
import { useAccess } from "../../access/AccessContext";

export const NoAccess = () => (
  <div className="flex h-full min-h-[60vh] flex-col items-center justify-center text-center px-6">
    <div className="mb-4 flex h-14 w-14 items-center justify-center rounded-full bg-slate-100">
      <ShieldOff className="h-7 w-7 text-slate-500" />
    </div>
    <h2 className="text-lg font-semibold text-slate-900">You don't have access to this page</h2>
    <p className="mt-1 max-w-sm text-sm text-slate-500">
      Ask an owner or an admin with Roles & Permissions access to grant it to your role.
    </p>
  </div>
);

const RequirePermission = ({ module, action = "view", children }) => {
  const { can, loading } = useAccess();
  if (loading) return null;
  return can(module, action) ? children : <NoAccess />;
};

export default RequirePermission;
